function _empty() {}

const fields = ['propertyId', 'businessId', 'planId', 'id', 'enabled'];

function _awaitIgnored(value, direct) {
  if (!direct) {
    return value && value.then ? value.then(_empty) : Promise.resolve();
  }
}

const PagedList = require('../entities/paged-list');

function _invoke(body, then) {
  var result = body();

  if (result && result.then) {
    return result.then(then);
  }

  return then(result);
}

const symmetricDifference = require('../utils/symmetricDifference');

function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

function _call(body, then, direct) {
  if (direct) {
    return then ? then(body()) : body();
  }

  try {
    var result = Promise.resolve(body());
    return then ? result.then(then) : result;
  } catch (e) {
    return Promise.reject(e);
  }
}

class PolicyRepo {
  constructor(client
  /*: ApiClient*/
  ) {
    this.client = client;
  }

  list(propertyId
  /*: string*/
  )
  /*: Promise<PagedList<Object>>*/
  {
    const req = new this.client.Request(`/properties/${propertyId}/policies`, {}, fields);
    return this.client.get(req);
  }

  find(propertyId
  /*: string*/
  , businessId
  /*: string*/
  , customFields
  /*: Array<string>*/
  )
  /*: Promise<Object | null>*/
  {
    const req = new this.client.Request(`/properties/${propertyId}/businesses/${businessId}/policy`, {}, customFields || fields);
    return this.client.get(req).catch(err => {
      if (err.status === 404) return null;
      return Promise.reject(err);
    });
  } // FIXME: Using default plan instead of accepting one as a param


  link(propertyId
  /*: string*/
  , businessId
  /*: string*/
  , planId
  /*: string*/
  )
  /*: Promise<Object>*/
  {
    return this.client.properties.for(propertyId).plans.getDefault().then(plan => {
      const params = {
        businessId,
        planId: plan.id,
        enabled: true
      };
      const req = new this.client.Request(`/properties/${propertyId}/policies`, params, fields);
      return this.client.post(req);
    });
  }
  /* eslint-disable-next-line class-methods-use-this */


  unlink(propertyId
  /*: string*/
  , businessId
  /*: string*/
  )
  /*: Promise<Object>*/
  {
    throw new Error('Policy Business unlink deprecated. Use delete instead.'); // return this.find(propertyId, businessId)
    //   .then((policy) => {
    //     const req = new this.client.Request(`/properties/${propertyId}/policies/${policy.id}`);
    //     return this.client.delete(req);
    //   });
  }

  getLocationIds(propertyId
  /*: string*/
  , policyId
  /*: string*/
  )
  /*: Promise<PagedList<Object>>*/
  {
    const req = new this.client.Request(`/properties/${propertyId}/policies/${policyId}`, undefined, ['locationIds']);
    return this.client.get(req).then(r => r.locationIds);
  }

  addLocation(propertyId
  /*: string*/
  , businessId
  /*: string*/
  , locationId
  /*: string*/
  )
  /*: Promise<Object>*/
  {
    const path = `/properties/${propertyId}/businesses/${businessId}/locations/${locationId}/policy/link`;
    const req = new this.client.Request(path);
    return this.client.post(req);
  }

  removeLocation(propertyId
  /*: string*/
  , businessId
  /*: string*/
  , locationId
  /*: string*/
  )
  /*: Promise<Object>*/
  {
    const path = `/properties/${propertyId}/businesses/${businessId}/locations/${locationId}/policy/link`;
    const req = new this.client.Request(path);
    return this.client.delete(req);
  }

  reconcileLocations(propertyId
  /*: string*/
  , businessId
  /*: string*/
  , policyId
  /*: string*/
  , locationIds
  /*: Array<string>*/
  = [], {
    /*: { addOnly: boolean, removeOnly: boolean }*/

    addOnly,
    removeOnly
  } = {})
  /*: Promise<boolean>*/
  {
    const _this = this;

    return _call(function () {
      return _await(_this.getLocationIds(propertyId, policyId), function (currentLocationIds) {
        const {
          left: toRemove,
          right: toAdd
        } = symmetricDifference(currentLocationIds, locationIds);
        return _invoke(function () {
          if (!addOnly) {
            return _awaitIgnored(Promise.all(toRemove.map(locationId => _this.removeLocation(propertyId, businessId, locationId))));
          }
        }, function () {
          return _invoke(function () {
            if (!removeOnly) {
              return _awaitIgnored(Promise.all(toAdd.map(locationId => _this.addLocation(propertyId, businessId, locationId))));
            }
          }, function () {
            return true;
          });
        });
      });
    });
  }

  update(propertyId
  /*: string*/
  , policyId
  /*: string*/
  , updates
  /*: Object*/
  ) {
    const req = new this.client.Request(`/properties/${propertyId}/policies/${policyId}`, updates, fields);
    return this.client.patch(req);
  }

  disable(propertyId
  /*: string*/
  , businessId
  /*: string*/
  )
  /*: Promise<Object>*/
  {
    return this.find(propertyId, businessId).then(policy => this.update(propertyId, policy.id, {
      enabled: false
    }));
  }

  enable(propertyId
  /*: string*/
  , businessId
  /*: string*/
  )
  /*: Promise<Object>*/
  {
    return this.find(propertyId, businessId).then(policy => this.update(propertyId, policy.id, {
      enabled: true
    }));
  }

  ensureActivePolicy(propertyId
  /*: string*/
  , businessId
  /*: string*/
  )
  /*: Promise<Object>*/
  {
    return this.find(propertyId, businessId).then(policy => {
      if (!policy) return this.link(propertyId, businessId);
      if (!policy.enabled) return this.enable(propertyId, businessId);
      return policy;
    });
  }

}

module.exports = PolicyRepo;